import { render, staticRenderFns } from "./OfficialSite.vue?vue&type=template&id=a0660dce&scoped=true"
import script from "./OfficialSite.vue?vue&type=script&lang=js"
export * from "./OfficialSite.vue?vue&type=script&lang=js"
import style0 from "./OfficialSite.vue?vue&type=style&index=0&id=a0660dce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0660dce",
  null
  
)

export default component.exports